module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-4-f0caa4c49271a689973c80838e9160f8.svg";